import BConfig from "../../../modules/BConfig";
import BRequest from "../../../modules/BRequest";
import Edible from "./Edible";
import NavigationItem from "./NavigationItem";
import NavigationItemContainer from "./NavigationItemContainer";
import NoData from "./NoData";
import QueryPreloader from "./QueryPreloader";
import Showcase from "./Showcase";
import ShowcaseContainer from "./ShowcaseContainer";
import Tag from "./Tag";

export default class Form
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.diary-day-search-edibles-form`;

	static initialize()
	{
		this.addEventListeners();

		document.querySelectorAll(this.selector()).forEach(el => {
			(new this(el)).loadFrequentEdibles();
		});

		Edible.initialize();
		NavigationItem.initialize();
		Showcase.initialize();
		Tag.initialize();
	}

	static addEventListeners()
	{
		// Vyhledávání.
		let timeout;
		document.addEventListener("keyup", event => {
			if (event.target.matches(`${this.selector()} [name="query"]`)) {
				clearTimeout(timeout);
				timeout = setTimeout(() => {
					new this(event.target.closest(this.selector())).refreshQuery();
				}, 300);
			}
		});

		// Submit.
		document.addEventListener("submit", event => {
			if (event.target.matches(`${this.selector()}, ${this.selector()} *`)) {
				event.preventDefault();
				new this(event.target.closest(this.selector())).refreshQuery();
			}
		});
	}

	static getSearchURL()
	{
		return BConfig.getRoute("api.v2.edibles.search");
	}

	getDiaryDayElement()
	{
		return this.el.closest(`.diary-day`);
	}

	getDialogElement()
	{
		return this.el.closest(`dialog`);
	}

	getQueryElement()
	{
		return this.el.querySelector(`[name="query"]`);
	}

	setQueryElementValue(query)
	{
		this.getQueryElement().value = query;

		return this;
	}

	getQueryElementValue()
	{
		return this.getQueryElement().value.trim();
	}

	getQueryPreloader()
	{
		return new QueryPreloader(this.el.querySelector(QueryPreloader.selector()));
	}

	getNavigationItemContainer()
	{
		return new NavigationItemContainer(this.el.querySelector(NavigationItemContainer.selector()));
	}

	getShowcaseContainer()
	{
		return new ShowcaseContainer(this.el.querySelector(ShowcaseContainer.selector()));
	}

	getNoData()
	{
		return new NoData(this.el.querySelector(NoData.selector()));
	}

	reset(resetQuery = true)
	{
		this.getNavigationItemContainer().hide();
		this.getNoData().hide();
		this.getQueryPreloader().hide();
		this.getShowcaseContainer().showFrequent();
		this.resetTags();

		if (resetQuery) {
			this.setQueryElementValue("");
			this.setQuery("");
		}

		return this;
	}

	resetTags()
	{
		this.getShowcaseContainer().getShowcaseCollection().getShowcases().map(showcase => {
			showcase.resetTags();
		});
	}

	showOverview()
	{
		this.getNavigationItemContainer().getNavigationItemCollection().unselect().filterByAffix("all").select();
		this.getNavigationItemContainer().show();

		this.getShowcaseContainer().getShowcaseCollection().hide().filterByAffix("preview").showNotEmpty();
		this.getShowcaseContainer().showCategories();

		return this;
	}

	showCategory(category)
	{
		this.getNavigationItemContainer().getNavigationItemCollection().unselect().filterByCategory(category).select();
		this.getNavigationItemContainer().show();

		this.getShowcaseContainer().getShowcaseCollection().hide().filterByAffix("full").filterByCategory(category).show();
		this.getShowcaseContainer().showCategories();

		return this;
	}

	refreshQuery()
	{
		this.setQuery(this.getQueryElementValue());

		return this;
	}

	getQuery()
	{
		return this.el.dataset.query;
	}

	setQuery(query)
	{
		query = query.trim();

		if (query != this.el.dataset.query) {
			this.el.dataset.query = query;

			if (query.length == 0) {
				this.reset(false);
				return this;
			}

			this.getNoData().hide();
			this.getQueryPreloader().show();

			BRequest.get(Form.getSearchURL(), {
				page: 1,
				perPage: 25,
				query: query,
			}).then(response => {
				if (this.getQuery().trim() == response.data.query) {
					this.getQueryPreloader().hide();
					this.setFromQueryResponse(response);
				}
			});
		}

		return this;
	}

	setFromQueryResponse(response)
	{
		if (response.data.total) {
			this.getNavigationItemContainer().setFromQueryResponse(response);
			this.getShowcaseContainer().setFromQueryResponse(response);

			this.resetTags();
			this.showOverview();
			this.getNoData().hide();
		} else {

			this.getNoData().show();
		}

		return this;
	}

	loadFrequentEdibles()
	{
		BRequest.get(BConfig.getRoute("api.v2.edibles.frequent")).then(response => {
			this.getShowcaseContainer().getShowcaseCollection().filterByAffix("frequent").setFromResponse(response).show();
			this.getShowcaseContainer().showFrequent();
		});
	}
}
